// extracted by mini-css-extract-plugin
export default {"container":"style_container__-QLbV","card":"style_card__o3P2u","row":"style_row__j+fmA","btnsRow":"style_btnsRow__Pfmx-"};